import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { Page } from "../util/page";
import { AccessToken } from "./model/access-token";
import { CompanyDetails } from "./model/company-details";
import { Synchronization } from "./model/synchronization";

@Injectable()
export class QuickbookService {
  private companyDetails!: CompanyDetails;

  constructor(private httpClient: HttpClient) { }

  public getCompanyDetails(): Observable<CompanyDetails> {
    if (this.companyDetails != undefined) {
      return of(this.companyDetails);
    }

    return this.httpClient.get<CompanyDetails>("/api/quickbook/company")
      .pipe(tap(companyDetails => this.companyDetails = companyDetails));
  }

  public findAccessToken(): Observable<AccessToken> {
    return this.httpClient.get<AccessToken>("/api/quickbook/access-token");
  }

  public findAllSynchronizations(page: number, sort: string): Observable<Page<Synchronization>> {
    return this.httpClient.get<Page<Synchronization>>(`/api/quickbook/synchronization?page=${page}&sort=${sort}`);
  }

  public getTokens(code: string): Observable<HttpResponse<void>> {
    return this.httpClient.post<HttpResponse<void>>("/api/quickbook/access-token", { code: code });
  }

  public startNewSynchronization(): Observable<Synchronization> {
    return this.httpClient.post<Synchronization>("/api/quickbook/synchronization", {});
  }
}